import React, { useEffect } from 'react';
import { DndProvider } from 'react-dnd-cjs';
import HTML5Backend from 'react-dnd-html5-backend-cjs';
import i18next from 'i18next';
import { connect } from 'react-redux';
import {
  getAssets,
  getConfigFile,
  handleUserSession,
  setFilteredAssets,
  setFilters
} from '../actions';
import Dashboard from '../components/Dashboard/Dashboard';
import { withAuthenticator } from 'aws-amplify-react';
import { Loading } from 'carbon-components-react';

function DashboardContainer (state) {
  useEffect(() => {
    const loadDashboard = async () => {
      const token = await handleUserSession();
      token && Promise.all([state.Assets(token), state.ConfigFile(token)]);
    };
    loadDashboard();
    // eslint-disable-next-line
  }, []);

  async function setAndLoadNamespace (name) {
    await i18next.loadNamespaces(name);
    i18next.setDefaultNamespace(name);
  }

  if (state.configFile !== undefined) {
    setAndLoadNamespace(state.configFile.name);
  }

  return (
    <>
      {state.assets !== [] && state.configFile !== undefined ? (
        <DndProvider backend={HTML5Backend}>
          <Dashboard
            configFile={state.configFile}
            assets={state.assets}
            filters={state.filters}
            filteredAssets={state.filteredAssets}
          />
        </DndProvider>
      ) : (
        <Loading />
      )}
    </>
  );
}

const mapStateToProps = state => ({
  assets: state.assets,
  configFile: state.configFile,
  filters: state.filters,
  filteredAssets: state.filteredAssets
});

const mapDispatchToPropsActions = dispatch => ({
  Assets: (value) => dispatch(getAssets(value)),
  ConfigFile: (value) => dispatch(getConfigFile(value)),
  Filters: value => dispatch(setFilters(value)),
  FilteredAssets: value => dispatch(setFilteredAssets(value))
});

export default withAuthenticator(
  connect(mapStateToProps, mapDispatchToPropsActions)(DashboardContainer)
);
